import React, { useRef } from "react"
import {useOutsideClick} from "../../../hooks/utility/outside-click-hook";

const OutsideClickDetector = ({className, callback, children, key}) => {
    const wrapperRef = useRef(null)
    useOutsideClick(wrapperRef, callback)
    return <div key={key} className={className} ref={wrapperRef}>{children}</div>
}

export default OutsideClickDetector